import type { CollectionJSONObject } from '@ikegps/core-api';
import type { CollectionModel } from '../../model/collection/collection.data';
import type { IkeRestDepartment } from '../rest.department';
import { type IkeCacheObject, IkeRestObject } from './base';

export class IkeObjectCollection extends IkeRestObject<CollectionJSONObject> {
	className = 'Collection' as const;
	actionName = 'collection';
	object: CollectionJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
		this.cacheKeys['revision'] = true;
	}

	override updateCache<K extends keyof CollectionJSONObject>(
		key: K,
		result: CollectionJSONObject,
		rest: IkeRestDepartment
	) {
		super.updateCache(key, result, rest);

		this.cacheIfLatest('uuid', result, rest);
		this.cacheIfLatest('revision', result, rest);
	}
}

export const IkeObjectCollectionModel: IkeCacheObject<CollectionModel> = {
	className: 'CollectionModel',
	actionName: 'collection.model',

	canCache<K extends keyof CollectionModel>(key: K): boolean {
		return key === 'revision';
	},
};
